// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime"
import { useState, useRef } from "react"
import { Calendar } from "primereact/calendar"
import { addLocale } from "primereact/api"
import { calendarES } from "../../helpers"
import { Button } from "../../../Button"

const HeaderTemplate = ({
  calendarRef
}: any) => {
  return _jsx(
    Button,
    {
      className: "input-calendar_close-icon",
      iconLibrary: "fas",
      icon: "times",
      onClick: () => {
        calendarRef === null || calendarRef === void 0
          ? void 0
          : calendarRef.hideOverlay()
      },
    },
    void 0
  )
}
const DateRange = ({
  onChange
}: any) => {
  const calendarRef = useRef(null)
  const [dates, setDates] = useState()
  addLocale("es", calendarES)
  return _jsx(
    Calendar,
    {
      style: { width: "100%" },
      ref: calendarRef,
      value: dates,
      dateFormat: "dd/mm/yy",
      onChange: (e: any) => {
        let _a
        let _b
        setDates(e === null || e === void 0 ? void 0 : e.value)
        if (
          (((_a = e.value) === null || _a === void 0 ? void 0 : _a.length) &&
            e.value[0] &&
            e.value[1]) ||
          !((_b = e.value) === null || _b === void 0 ? void 0 : _b.length)
        ) {
          onChange(e.value)
        }
      },
      locale: "es",
      selectionMode: "range",
      headerTemplate: () =>
        _jsx(
          HeaderTemplate,
          {
            calendarRef:
              calendarRef === null || calendarRef === void 0
                ? void 0
                : calendarRef.current,
          },
          void 0
        ),
      showIcon: true,
      readOnlyInput: true,
      showButtonBar: true,
      inputClassName: "p-column-filter",
    },
    void 0
  );
}
export default DateRange
